import React from 'react';
import GrammarKata from '../components/GrammarKata';
import Leaderboard from '../components/Leaderboard';
import { useLanguage } from '../contexts/LanguageContext';

const Practice = () => {
    const { t } = useLanguage();
    
    return (
        <div style={{ background: '#f9fafb', minHeight: '100vh', padding: '40px 16px' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <h1 style={{ fontSize: 'clamp(24px, 5vw, 36px)', color: '#1f2937', marginBottom: '10px' }}>{t('practiceArena')}</h1>
                    <p style={{ fontSize: '18px', color: '#6b7280' }}>{t('practiceArenaDesc')}</p>
                </div>
                
                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
                    gap: '30px',
                    alignItems: 'start'
                }}>
                    {/* Grammar Kata Interactive Tool */}
                    <div>
                        <div style={{
                            background: '#fff',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
                            padding: '24px',
                            border: '1px solid #e5e7eb'
                        }}>
                            <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#111827' }}>
                                ?? Interactive Grammar Drills
                            </h2>
                            <GrammarKata />
                        </div>
                    </div>

                    {/* Live Leaderboard */}
                    <div>
                        <div style={{
                            background: '#fff',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
                            padding: '24px',
                            border: '1px solid #e5e7eb'
                        }}>
                            <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', color: '#111827' }}>
                                ?? Daily Arena Standings
                            </h2>
                            <Leaderboard />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Practice;
